import React from 'react';
import {Text, View, StyleSheet as PDFStyleSheet} from '@react-pdf/renderer';

interface Props {
  name: string;
  description?: string;
  date: string;
}

const Activity = ({name, description, date}: Props) => {
  const styles = PDFStyleSheet.create({
    activityTitle: {
      fontSize: 12,
    },
    activityDate: {
      fontSize: 12,
    },
    activityDescription: {
      width: '80%',
      fontSize: 11,
      fontWeight: 'normal',
      color: '#6a7886',
    },
    titleDateContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 4,
    },
  });

  return (
    <View>
      <View style={styles.titleDateContainer}>
        <Text style={styles.activityTitle}>{name}</Text>
        <Text style={styles.activityDate}>{date}</Text>
      </View>
      <Text style={styles.activityDescription}>{description}</Text>
    </View>
  );
};

export default Activity;
